import { render, staticRenderFns } from "./CdkOrder.vue?vue&type=template&id=90cac6c8&scoped=true&"
import script from "./CdkOrder.vue?vue&type=script&lang=js&"
export * from "./CdkOrder.vue?vue&type=script&lang=js&"
import style0 from "./CdkOrder.vue?vue&type=style&index=0&id=90cac6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cac6c8",
  null
  
)

export default component.exports